import {useCallback, useState} from 'react';

export function useRecalculate(): () => void {
  const [nonce, setNonce] = useState(0);
  const triggerChange = useCallback(() => {
    setNonce(nonce + 1);
  }, [nonce]);
  return triggerChange;
}
